export default __webpack_public_path__ + "static/media/something-wrong.3c646a11.png";